export class Place {

  id: string;
  title: string;
  date: number;
  placement: string;
  collection: string;
  type: string;
  material: string;
  description: string;
  images: PlaceImage[];

  artists: {
    name: string;
    url: string;
    type: string;
  }[];

  address: {
    line1: string;
    line2: string;
    city: string;
    state: string;
    zip: number;
  };

  location: {
    lat: number;
    lng: number;
  };

}

export class PlaceImage {
  url: string;
  title: string;
}
